module.exports = __webpack_public_path__ + "3df7f60e6f1c80bd319ea81a9b1db170.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-image-black.svg
// module id = 1005
// module chunks = 69